const translation = {
  GREETINGS: `Bonjour Je m'appelle`,
  MY_NAME: 'Fakhreddine Messaoudi',
  PROFFENCY: 'Développeur Full Stack',
  DOWNLOAD_RESUME_BTN: 'Télécharger le CV',
  CONTACT_BTN: `En Parlons`,
  SCROLL_DOWN: 'Défiler vers le bas',
};

export default translation;
